import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import {
  IonPage, IonContent, IonGrid, IonRow, IonCol,
} from '@ionic/react'
import RegisterForm from '../components/session/RegisterForm'
import LoadingModal from '../components/modals/LoadingModal'

const Register = () => {
  const location = useLocation()
  const { from } = location.state || { from: { pathname: '/' } }
  const [loading, setLoading] = useState()

  return (
    <IonPage>
      <IonContent>
        <IonGrid style={{ height: '100%' }}>
          <IonRow style={{ height: '100%' }} className='ion-align-items-center'>
            <LoadingModal isOpen={loading} />
            <IonCol offsetMd='3' sizeMd='6' offsetLg='4' sizeLg='4'>
              <RegisterForm loading={loading} setLoading={setLoading} returnTo={from} />
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  )
}

export default Register
